import { FlexBox } from 'src/ui/common/atoms/flex-box';
import { SvgIcon } from 'src/ui/common/atoms/svg-icon';
import { Typography } from 'src/ui/common/atoms/typography';
import { speed } from 'src/ui/common/config/animations';
import { IStyledSelectedOption } from 'src/ui/common/organisms/select/select.types';
import styled from 'styled-components';

export const StyledContent = styled.div<{ withSearch: boolean }>`
    background-color: ${({ theme }) => ` ${theme.colors.grey800}`};
    padding: 10px 0;
    margin-top: 2px;
    overflow-y: auto;
`;

export const StyledSearchContent = styled.div`
    background-color: red;
    padding: 20px;
    margin-top: 2px;
    margin-bottom: -2px;
    border-radius: 5px 5px 0 0;
    border-bottom: ${({ theme }) => `1px solid ${theme.colors.gs400}`};
`;

export const StyledArrow = styled(SvgIcon)<{ opened: boolean }>`
    cursor: pointer;
    position: absolute;
    right: 20px;
    top: 50%;
    margin-top: -9px;
    transform: ${({ opened }) => (opened ? 'rotate(180deg)' : 'rotate(0deg)')};
    transition: transform ${speed.content};
`;

export const StyledHeader = styled.div`
    cursor: pointer;
    display: inline-flex;
    width: 100%;
    position: relative;
    user-select: none;

    & input {
        pointer-events: none;
        padding-right: 48px;
        text-overflow: ellipsis;
        width: 100%;
    }
`;

export const StyledOption = styled.div<{ selected: boolean }>`
    cursor: pointer;
    background-color: ${({ theme, selected }) => (selected ? theme.colors.grey900 : theme.colors.grey800)};
    padding: 10px 20px;
    color: ${({ theme }) => `${theme.colors.grey400}`};
    user-select: none;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    animation: background-color ${speed.content};

    &:hover {
        background-color: ${({ theme }) => theme.colors.grey900};
    }
`;

export const StyledSelectedOption = styled(FlexBox)<IStyledSelectedOption>`
    height: 50px;
    width: 100%;
    border: 1px solid ${({ opened, theme }) => (opened ? theme.colors.gs400 : theme.colors.gs450)};
    border-radius: 5px;
    padding: 0 15px;

    &:hover {
        border-color: ${({ theme }) => theme.colors.gs400};
    }
`;

export const StyledTypographyError = styled(Typography)`
    margin-top: 10px;
`;

export const StyledInputWrapper = styled(FlexBox)<{ emptyIcon: boolean }>`
    width: 100%;
    position: relative;

    svg {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 20px;
    }

    input {
        padding-left: ${({ emptyIcon }) => emptyIcon && '48px'};
    }
`;